import React, { useMemo } from 'react';
import { DictionaryItem } from 'global';
import { useQuery } from '@apollo/client';
import { Autocomplete, TextField } from '@mui/material';

import { dealActivityApi } from '../../api';

interface Props {
  userProfileId: string | null;
  onChange: (userProfileId: string | null) => void;
}

export const CalendarUserSelect = ({ userProfileId, onChange }: Props) => {
  const { data, loading } = useQuery<{ dealActivity: { dealContacts: DictionaryItem[] } }>(
    dealActivityApi.dealContacts
  );

  const options = useMemo(
    () =>
      (data?.dealActivity?.dealContacts ?? [])
        .map(option => ({ ...option, label: option.label.trim() }))
        .sort((a, b) => {
          // Users without a name go last instead of first.
          if (!a.label || !b.label) return Number(!a.label) - Number(!b.label);

          return a.label.localeCompare(b.label, 'en', { sensitivity: 'base', numeric: true });
        }),
    [data]
  );

  return (
    <Autocomplete
      size="small"
      sx={{ width: '18rem' }}
      loading={loading}
      options={options}
      value={options.find(option => option.value === userProfileId) ?? null}
      onChange={(_, option) => onChange(option?.value ?? null)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} variant="outlined" label="View calendar of" />}
    />
  );
};
